// src/components/LoaderOverlay.jsx
import React from "react";

export default function LoaderOverlay({
    text = "Loading...",
    mode = "normal",
    progress = 0,
    showOverlay = true,
    blur = true,
    overlayStyle,
}) {
    const wrapperClasses = showOverlay
        ? `fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 ${
              blur ? "backdrop-blur-sm" : ""
          }`
        : "flex w-full items-center justify-center";
    const safeProgress = Math.max(0, Math.min(100, Math.round(progress)));
    const isProgressMode = mode === "progress";

    return (
        <div className={wrapperClasses} style={overlayStyle}>
            <div className="flex w-full max-w-sm flex-col items-center gap-3 rounded-lg bg-white px-6 py-4 shadow-lg">
                <div className="w-10 h-10 border-4 rounded-full animate-spin border-slate-300 border-t-slate-700" />
                {isProgressMode ? (
                    <>
                        <p className="text-sm font-semibold text-slate-700">
                            {safeProgress}% complete
                        </p>
                        <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-200">
                            <div
                                className="h-full rounded-full bg-slate-700 transition-[width] duration-500 ease-out"
                                style={{ width: `${safeProgress}%` }}
                            />
                        </div>
                        <p className="text-center text-sm font-medium text-slate-500">
                            {text}
                        </p>
                    </>
                ) : (
                    <p className="text-sm font-medium text-slate-700">{text}</p>
                )}
            </div>
        </div>
    );
}
